var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-form-add-product",
      title: _vm.$t("Adicionar produtos"),
      show: _vm.showSidebar,
      fetching: _vm.fetching,
      saving: _vm.saving,
      width: "90%",
      "confirm-button-text": _vm.$t("Ok"),
      "hide-cancel-button": true,
    },
    on: { save: _vm.onSaveItem, hidden: _vm.hide },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "b-card-actions",
              {
                attrs: {
                  "action-refresh": "",
                  "show-loading": _vm.fetching || _vm.busy,
                },
                on: {
                  refresh: function ($event) {
                    return _vm.getSkus({ storeId: _vm.storeId })
                  },
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "title" }, slot: "title" },
                  [
                    _c("e-page-size-selector", {
                      attrs: { "per-page": _vm.paging.pageSize },
                      on: { change: _vm.pageSizeChange },
                    }),
                  ],
                  1
                ),
                _c(
                  "e-filters",
                  {
                    staticClass: "mb-2 card-bordered",
                    attrs: {
                      "search-text": _vm.$t("Filtrar"),
                      searching: _vm.fetching,
                      title: _vm.$t("Filtrar Produtos"),
                    },
                    on: { search: _vm.filterData, reset: _vm.resetFilters },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-skuId",
                                type: "number",
                                label: _vm.$t("Código"),
                                placeholder: _vm.$t("Código"),
                              },
                              model: {
                                value: _vm.filters.skuId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "skuId", $$v)
                                },
                                expression: "filters.skuId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-ean",
                                type: "number",
                                label: _vm.$t("EAN/GTIN"),
                                placeholder: _vm.$t("Código de barras"),
                              },
                              model: {
                                value: _vm.filters.ean,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "ean", $$v)
                                },
                                expression: "filters.ean",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-name",
                                label: _vm.$t("Nome"),
                                placeholder: _vm.$t("Nome"),
                              },
                              model: {
                                value: _vm.filters.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "name", $$v)
                                },
                                expression: "filters.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-maximumStock",
                                label: _vm.$t("Estoque até"),
                                placeholder: _vm.$t("Ex: 10"),
                                instruction: _vm.$t(
                                  "Quando preenchido, o sistema só trará produtos que tenham no máximo o estoque informado neste campo"
                                ),
                              },
                              model: {
                                value: _vm.filters.maximumStock,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "maximumStock", $$v)
                                },
                                expression: "filters.maximumStock",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-belowMinimumStock",
                                type: "switch",
                                label: _vm.$t("Abaixo do mínimo"),
                              },
                              model: {
                                value: _vm.filters.belowMinimumStock,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.filters,
                                    "belowMinimumStock",
                                    $$v
                                  )
                                },
                                expression: "filters.belowMinimumStock",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-brand",
                                type: "vue-select",
                                label: _vm.$t("Marca"),
                                placeholder: _vm.$t("Selecione uma marca"),
                                options: _vm.getComboBrands,
                              },
                              model: {
                                value: _vm.filters.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "brandId", $$v)
                                },
                                expression: "filters.brandId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-group",
                                type: "vue-select",
                                label: _vm.$t("Grupo"),
                                placeholder: _vm.$t("Selecione um grupo"),
                                options: _vm.getComboGroups,
                                disabled: _vm.isGroupLockedByRequisition,
                                instruction: _vm.isGroupLockedByRequisition
                                  ? _vm.$t(
                                      "A requisição está restrita a este grupo de produto"
                                    )
                                  : "",
                              },
                              on: { input: _vm.selectGroup },
                              model: {
                                value: _vm.filters.groupId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "groupId", $$v)
                                },
                                expression: "filters.groupId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-subgroup",
                                type: "vue-select",
                                label: _vm.$t("Subgrupo"),
                                placeholder: _vm.$t("Selecione um subgrupo"),
                                options: _vm.getComboSubgroups,
                                disabled: !_vm.filters.group,
                              },
                              model: {
                                value: _vm.filters.subgroupId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "subgroupId", $$v)
                                },
                                expression: "filters.subgroupId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "filter-department",
                                type: "vue-select",
                                label: _vm.$t("Departamento"),
                                placeholder: _vm.$t(
                                  "Selecione um departamento"
                                ),
                                options: _vm.getComboDepartments,
                              },
                              model: {
                                value: _vm.filters.departmentId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "departmentId", $$v)
                                },
                                expression: "filters.departmentId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("b-table", {
                  ref: "table-skus",
                  staticClass: "mb-1 bordered",
                  attrs: {
                    "show-empty": "",
                    striped: "",
                    responsive: "",
                    fields: _vm.fields,
                    items: _vm.skuSearchResults,
                    "no-local-sorting": "",
                    "sort-by": _vm.sorting.sortBy,
                    "sort-desc": _vm.sorting.sortDesc,
                  },
                  on: {
                    "update:sortBy": function ($event) {
                      return _vm.$set(_vm.sorting, "sortBy", $event)
                    },
                    "update:sort-by": function ($event) {
                      return _vm.$set(_vm.sorting, "sortBy", $event)
                    },
                    "update:sortDesc": function ($event) {
                      return _vm.$set(_vm.sorting, "sortDesc", $event)
                    },
                    "update:sort-desc": function ($event) {
                      return _vm.$set(_vm.sorting, "sortDesc", $event)
                    },
                    "sort-changed": function ($event) {
                      return _vm.getSkus({ storeId: _vm.storeId })
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(action)",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            [
                              _c("e-grid-actions", {
                                attrs: {
                                  "show-update": false,
                                  "show-delete": false,
                                  buttons: [
                                    {
                                      icon: "plus",
                                      variant: "primary",
                                      title: _vm.$t("Adicionar produto"),
                                      event: "product-add",
                                    },
                                  ],
                                },
                                on: {
                                  "product-add": function ($event) {
                                    return _vm.addProduct(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(skuName)",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("e-product-router-link", {
                            attrs: {
                              "sku-id": item.sku.id,
                              "product-id": item.sku.productId,
                              "product-name": item.sku.name,
                              ean: item.sku.ean,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("e-pagination-summary", {
                          attrs: {
                            "current-page": _vm.paging.currentPage,
                            "per-page": _vm.paging.pageSize,
                            total: _vm.paging.rowCount,
                            "total-on-page": _vm.paging.rowsInCurrentPage,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("b-pagination", {
                          attrs: {
                            align: "right",
                            "total-rows": _vm.paging.rowCount,
                            "per-page": _vm.paging.pageSize,
                            "aria-controls": "user-table",
                          },
                          on: { change: _vm.pageChange },
                          model: {
                            value: _vm.paging.currentPage,
                            callback: function ($$v) {
                              _vm.$set(_vm.paging, "currentPage", $$v)
                            },
                            expression: "paging.currentPage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }